export const TenantIds = {
  ALC: '9BF69A14-0E14-46C0-ADDB-ED107AC6526C',
  APK: '7E4285A1-B0A9-4D64-8CE9-16A210DFAA34',
  Aspire: '541FC0D3-01FA-4556-88AD-D1AEACBB8D84',
  BEI: '025C20CD-E7CA-4F89-9330-607F2BA544BE',
  CAB: 'F1C97CAF-D8D9-40C0-BEC9-67B39486857E',
  CNT: '0E9F6650-55AE-11EB-B3DB-07FE15A966A4',
  D_F: '11B9218C-AA21-498D-86CD-7F906B6F485F',
  ESE: '828D8188-E9D8-41F9-9921-FF4A68992B55',
  FGL: 'FF5B425F-B64F-4605-ADD0-DC6F2B923501',
  GGC: 'F453DF1B-0E2D-42D2-818F-6534170340AA',
  GTH: '11A4864B-23F7-4E46-8414-EC256A3BC950',
  H_C: '3A74F278-69C1-48B9-9722-4C92EAB6F7D2',
  JDSons: 'F9074FA5-1A5D-49F7-B773-D17BB4CFF4E7',
  JSSJ: '6C8FAAD6-D993-4096-970E-C4725EC5EADA',
  JWI: 'ECED2CE9-2457-4F46-9FBE-884A5B18D297',
  JWZ: 'BD055B36-EAB9-4B3E-AE6F-1FDA39F97D7E',
  KTI: 'B3363D14-4A46-4E2A-8632-628BE6A6AF8D',
  MEI: '2951E89E-63D0-47DA-8B39-0730ACE257E6',
  Miller: '10DC52C9-62EE-4F15-8B1D-970F39C70F39',
  NBTGID: '14630EF4-883E-4052-A376-4E5A9CF7C124',
  PDT: 'D04BA955-7E8C-4151-A8DA-55BE87E1C282',
  Razor: '9F6F31A7-6494-4D49-8325-334F948F3007',
  RLI: '7CDF2A5E-B170-4EF3-8BF3-BCF5E969D739',
  SDFC: 'DCF429AD-DAD2-4C70-A575-9474CFF95514',
  SFG: '8FD46B3C-87D8-4258-BD56-7165BDA10A2E',
  ST: '0E724254-17AA-4973-86EC-EC8226C7C818',
  SandT: '6955FD35-53B2-41FA-878D-56F51D387FFE',
  Sophia: '9EAC447F-8A0F-4104-AB22-DEFB1160BF5F',
  SYCS: 'DA9FFFDE-C051-4261-AF0E-12D5050B9E26',
  TCW: '373AD665-4D61-427C-8BCD-25D1D4F8B802',
  T27: 'A4B256AA-C8EE-4DE4-81CD-A4FB78F54DC9',
  TVI: '855C3433-73F2-4DA8-9019-63DC516DB3EA',
  ZTI: '08255518-FB07-43FB-A308-94CEF2C486B4'
};
